import React from "react";
import ActivePlayer from "../components/ActivePlayer";
import DoublesDiceScreen from "../components/DoublesDiceScreen";
import OtherPlayer from "../components/OtherPlayer";
import OtherPlayerDicespecial6 from "../components/OtherPlayerDicespecial6";

const CTDiceRollResult = ({
  screens,
  isActivePlayer,
  diceData,
  isReaderPlayer,
  currentPlayerInfo,
  roomId,
  currentPlayer,
  discard_pile,
  OtherPlayers,
  CoverUpData,
  currentPlayerCard,
  playersWithCard,
  playersWithCardInfo,
  playerSelected,
  cardSelected,
  stealButton,
  showCardList,buzzer_sound,default_audio_effect,joke
}) => {
  const diceSpecial = diceData?.dice_special || null;
  return (
    <>
      {isActivePlayer ? (
        <ActivePlayer
        screens={screens}
          diceData={diceData}
          roomId={roomId}
          currentPlayer={currentPlayer}
          discard_pile={discard_pile}
          OtherPlayers={OtherPlayers}
          CoverUpData={CoverUpData}
          playersWithCard={playersWithCard}
          playersWithCardInfo={playersWithCardInfo}
          playerSelected={playerSelected}
          cardSelected={cardSelected}
          stealButton={stealButton}
          buzzer_sound={buzzer_sound}
          default_audio_effect={default_audio_effect}
        />
      ) : diceSpecial === 6 ? (
        <OtherPlayerDicespecial6
        screens={screens}

          playersWithCardInfo={playersWithCardInfo}
          roomId={roomId}
          currentPlayerCard={currentPlayerCard}
          currentPlayer={currentPlayer}
          showCardList={showCardList}
          isReaderPlayer={isReaderPlayer}
          currentPlayerInfo={currentPlayerInfo}
        />
      ) : (
        <OtherPlayer
        screens={screens}
        joke={joke}
          isReaderPlayer={isReaderPlayer}
          currentPlayerInfo={currentPlayerInfo}
          currentPlayerCard={currentPlayerCard}
        />
      )}
    </>
  );
};

export default CTDiceRollResult;
